<template>
    <div class="service tea">
        <navBar></navBar>
        <div class="s-banner"></div>
        <div class="s-title">
            <h2 class="s-txt-h2">线下3S教学</h2>
            <p class="s-intro">3S教学法的精髓是对人的培养</p>
        </div>
        <div class="t-content">
            <div class="t-content-item">
                <div class="item-icon item-icon-line">1</div>
                <div class="item-con">
                    <h3 class="t-con-title">Self-Learning 自主学习</h3>
                    <ul class="t-con-intro">
                        <li>1.教学的主体是学生</li>
                        <li>2.学生是真正的演员</li>
                        <li>3.教师变成导演、教练</li>
                    </ul>
                    <img class="t-con-img" src="https://restaskimg.civaonline.cn/imagesH5/service/3s-1.png" alt="">
                </div>
            </div>
            <div class="t-content-item">
                <div class="item-icon item-icon-line">2</div>
                <div class="item-con">
                    <h3 class="t-con-title">Self-Management 自我管理</h3>
                    <ul class="t-con-intro">
                        <li>1.学生在训练、在讨论、在PK、在表演总结</li>
                        <li>2.老师负责引导、营造氛围、总结</li>
                        <li>3.学生分组自主管理学习、班务</li>
                    </ul>
                    <img class="t-con-img" src="https://restaskimg.civaonline.cn/imagesH5/service/3s-2.png" alt="">
                </div>
            </div>
            <div class="t-content-item">
                <div class="item-icon">3</div>
                <div class="item-con">
                    <h3 class="t-con-title">Self-Achievement 自我实现</h3>
                    <ul class="t-con-intro">
                        <li>1.激发学习动机</li>
                        <li>2.保持学习兴趣</li>
                        <li>3.体会学习成就感</li>
                    </ul>
                    <img class="t-con-img" src="https://restaskimg.civaonline.cn/imagesH5/service/3s-3.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from '@/components/navBar';
export default {
  components: {
    navBar,
  },
}
</script>

<style scoped lang="less">
.tea{
    .s-banner{
        background: url("https://restaskimg.civaonline.cn/imagesH5/service/3s-banner.png") no-repeat center center / cover;
    }
    .t-content{
        margin-top: 82px;
        padding: 0 63px 150px;
        .t-content-item{
            padding : 0 0 120px;
            display: flex;
            .item-icon{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                background: #FF7501;
                font-family: SyMedium;
                font-size: 28px;
                color: #FFFFFF;
                line-height: 50px;
                text-align: center;
                position: relative;
            }
            .item-icon-line:after{
                content: " ";
                width: 2px;
                height: 565px;
                background: #E0E0E0;
                position: absolute;
                top: 50px;
                left: 50%;
                margin-left: -1px;
            }
            .item-con{
                flex: 1;
                margin-left: 37px;
                .t-con-intro{
                    margin-top: 8px;
                    margin-bottom: 45px;
                    li{
                        margin-top: 12px;
                        font-family: SyMedium;
                        color: #686B75;
                    }
                }
                .t-con-img{
                    width: 531px;
                    display: block;
                }
            }
        }
    }
}
</style>
